import type { AxiosError } from 'axios';

export type NotAuthorizedExceptionBody = {
  message?: string;
  code?: number;
  exceptionType?: string;
};

// Some code paths might throw an object that looks like { data: ... }
type WithData<T> = { data?: T };

const getErrorData = (err: unknown): NotAuthorizedExceptionBody | undefined => {
  // AxiosError shape
  const axiosErr = err as AxiosError<NotAuthorizedExceptionBody>;
  const fromAxios = axiosErr?.response?.data;

  // Fallback shape: { data: ... }
  const fromDataProp = (err as WithData<NotAuthorizedExceptionBody>)?.data;

  return fromAxios ?? fromDataProp;
};

export const isRefreshTokenExpiredFromTokenLogin = (err: unknown): boolean => {
  const data = getErrorData(err);
  const msg = (data?.message ?? '').toLowerCase();

  return (
    data?.code === 400 &&
    data?.exceptionType === 'NotAuthorizedException' &&
    msg.includes('refresh token') &&
    msg.includes('expired')
  );
};
